import { render, staticRenderFns } from "./PreciosButacas.vue?vue&type=template&id=22b562fd"
import script from "./PreciosButacas.vue?vue&type=script&lang=js"
export * from "./PreciosButacas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports